<template>
	<div>
		<NavHeader/>


		<div class="main-header-content">
			<div class="container">
				<h3>Personal Payments Terms & Conditions</h3>
			</div>
		</div>

		<div class="divider"></div>


		<div class="container">
			<div class="information-detail">
				<privacy-sidebar />
				<!-- <div class="sidebar">
			<ul class="main-menu">
				<li class="main-list">
					<h2 class="list-header pdt0">License <i class="material-icons">expand_more</i></h2>
					<ul class="sub-menu">
						<li><a href="">Money Service Business License</a></li>
					</ul>
				</li>

				<li class="main-list">
					<h2 class="list-header">Terms & Conditions <i class="material-icons">expand_more</i></h2>
					<ul class="sub-menu">
						<li><a href="" class="active">Personal Payments Terms & Conditions</a></li>
						<li><a href="">Business Payments Terms & Conditions</a></li>
						<li><a href="">Moneygram Terms & Conditions</a></li>
					</ul>
				</li>

				<li class="main-list">
					<h2 class="list-header">Secutity <i class="material-icons">expand_more</i></h2>
					<ul class="sub-menu">
						<li><a href="">Privacy & Policy</a></li>
						<li><a href="">Cautionary Statement</a></li>
						<li><a href="">Security & Compliance</a></li>
					</ul>
				</li>

				<li class="main-list">
					<h2 class="list-header">FAQs <i class="material-icons">expand_more</i></h2>
					<ul class="sub-menu">
						<li><a href="">Personal Payments</a></li>
						<li><a href="">Business Payments</a></li>
					</ul>
				</li>
			</ul>
		</div> -->

				<div class="information-content">
					<h6 class="info-header"><strong>E-REMIT USER AGREEMENT<br> (Applicable for Individual User)</strong></h6>
					
					<p class="content-para">THE USE OF MERCHANTRADE ASIA SDN BHD (Registration No: 410591-T) (MERCHANTRADE)’S e-Remit
						SERVICES ARE SUBJECT TO THIS E-REMIT USER AGREEMENT (‘THIS AGREEMENT’) WHICH DESCRIBES
						THE RIGHTS AND OBLIGATIONS OF THE USER AND MERCHANTRADE’S RIGHTS AND
						OBLIGATIONS. PLEASE READ THIS AGREEMENT CAREFULLY. BY REQUESTING AND/OR USING THIS eRemit SERVICES, YOU ACKNOWLEDGE TO HAVE READ, UNDERSTOOD AND AGREE TO BE BOUND BY
						THE TERMS AND CONDITIONS OF THIS AGREEMENT.</p>
					<p class="content-para"><strong>1. DEFINITIONS AND INTERPRETATIONS</strong></p>
					<p class="content-para">1.1
						<strong>“Applicable Laws”</strong> ” means the laws, regulations, policies, guidelines, rules and
						requirements (whether or not having the force of law) in the relevant jurisdiction
						governing Merchantrade and/or the User (as may be applicable), including but without
						limitation to Anti-Money Laundering, Anti-Terrorism Financing and Proceeds of
						Unlawful Activities Act 2001, Money Services Business Act 2011, Personal Data
						Protection Act 2010 and shall include such other requirements that Merchantrade
						stipulates from time to time.</p>

					<p class="content-para">1.2
						<strong>"Business day"</strong> means any day on which both the banks in Malaysia and Beneficiary
						Country are open for business and is subject always to FPX services availability.</p>

					<p class="content-para">1.3
						<strong>“Beneficiary”</strong> means the beneficiary who ultimately receives the payment in
						accordance to the User’s instruction through the e-Remit System.</p>

					<p class="content-para">1.4
						<strong>“Beneficiary Account”</strong> means the bank account of the Beneficiary authorized by the
User for the purpose of money transfer/remittance payout.</p>
					<p class="content-para">1.5
						<strong>“Beneficiary Bank”</strong> means the bank located at the Beneficiary’s Country at which the
Beneficiary maintains an Account for the purpose of crediting the remittance payout.
</p>
					<p class="content-para">1.6
						<strong>“Beneficiary Country”</strong> means the country of the Beneficiary where the crediting of the
Beneficiary’s account is to be made.
</p>

					<p class="content-para">1.7
						<strong>“Beneficiary Currency”</strong> means the currency in which the remittance payout is to be
made.</p>
					<p class="content-para">1.8
						<strong>“Beneficiary Card”</strong> means the personal card(s) belonging to the Beneficiary, bearing
the name VISA and/or service mark of VISA which is issued by any bank or financial
institution located overseas for the purposes of crediting remittance payout.</p>

					<p class="content-para">1.9
						<strong>“e-Remit Services”</strong> or <strong>“Services”</strong> refers to an online money transfer service offered by
Merchantrade to facilitate User’s transfer of funds to the Beneficiary in the Beneficiary
Currency.
</p>
					<p class="content-para">1.10
						<strong>“e-Remit System”</strong> or <strong>“System”</strong> means Merchantrade’s proprietary online remittance
/ money transfer system accessible by the User via Website or mobile device or such
other electronic devices which are capable of supporting the e-Remit Services
application for purposes of carrying out the Transaction.
					</p>
					<p class="content-para">1.11
						<strong>“FPX”</strong> refers to Financial Processing Exchange, a national online payment gateway
which is jointly developed by Financial Institutions and is owned by Payments Network
Malaysia Sdn Bhd.
</p>
					<p class="content-para">1.12
						<strong>“Loss”</strong> includes loss, damage, claim, costs, subscription fees, charges, damages and /
or expenses of whatsoever nature without limitation arising from contract, tort, equity
or any other principles of law or legal theory (including any loss of profits, lost of
savings, loss of data, loss of opportunity, loss of goodwill, special, incidental, punitive
or exemplary losses and consequential damages) and howsoever arising whether
direct, indirect, joint, several, actual, contingent or otherwise (including legal fees on
a full indemnity basis), and includes without limitation claims made by third parties
and claims for defamation, infringement of intellectual property rights, death, bodily
injury, wrongful use of computers and unauthorized or illegal access to computers
(including but not limited to hacking), property damage or pecuniary losses howsoever
arising.</p>
					<p class="content-para">1.13
						<strong>“Merchantrade”</strong> refers to Merchantrade Asia Sdn Bhd (Registration No. 410591-T), a
company incorporated under the laws of Malaysia with its corporate office at Suite
1632, 16th Floor, Lobby 7, Block A, Damansara Intan, No. 1 Jalan SS20/27, 47400
Petaling Jaya , Selangor Darul Ehsan and includes its successors and assigns.</p>
					<p class="content-para">1.14
						<strong>“Net Payout Amount”</strong> means the net amount to be credited to the Beneficiary’s
Account in the currency of the Beneficiary’s country.</p>
					<p class="content-para">1.15
						<strong>“Privacy Notice”</strong> means Merchantrade’s policies and principles pertaining to the
collection, use and storage of personal information of the User as may be amended
from time to time and made available at <a href="https://www.eremit.com.my">www.eremit.com.my</a></p>
					<p class="content-para">1.16
						<strong>“Password ”</strong> means an alpha-numeric access code with at least one (1) special
character opted by the User’s authorised persons for the purpose of gaining access to
the e-remit for Business System to:
<ol type="a">
	<li>access the User’s Account to carry out money transfer transaction.</li>
	<li>initiate change in address, view previous transaction records and ascertain status of current transaction.</li>
	<li>perform such other acts as permitted by the e-Remit System from time to time.</li>
</ol>
</p>
					<p class="content-para">1.17
						<strong>“Rate Table”</strong> means a table of Foreign Exchange rate where the conversion rate of
each payout currencies are displayed and is subject to change from time to time
according to the prevailing market condition.
</p>
					<p class="content-para">1.18
						<strong>"Service Charge"</strong> means fee imposed by Merchantrade to the User for each
remittance instruction made and is subject to change at Merchantrade’s sole and
absolute discretion</p>
					<p class="content-para">1.19
						<strong>“Terms of Services” or “these Terms”</strong> means all the terms and conditions under which
the Services is offered by Merchantrade to the User.</p>
					<p class="content-para">1.20
						<strong>"Transaction"</strong> means online remittance or money transfer transaction carried out by
the User through the e-Remit System.</p>
					<p class="content-para">1.21
						<strong>“Taxation Authority”</strong>  means any government, state or municipility or any local, state,
federal or other authority, body of official exercising a fiscal, revenue or exice function.</p>
					<p class="content-para">1.22
						<strong>“Taxes”</strong> means any tax, levy, duty, charge, deduction and witholding (without
limitation goods and service tax (GST), if applicable) , however it is described as that is
imposed under the Applicable Laws by the Taxation Authority and any related interest,
penalty, fine or other charges.
</p>
					<p class="content-para">1.23
						<strong>“User/You/Your”</strong> means an individual (excluding Company / Sole-Proprietorship /
Partnership / Association) whose application for Services has been accepted and
registered with Merchantrade.</p>
					<p class="content-para">1.24
						<strong>“User’s Account”</strong> refers to the facility provided to the User upon registration for
uniquely identifying the User of the Services and for accessing the Services.</p>
					<p class="content-para">1.25 <strong>“Visitor”</strong> means any individual who is not a User that accesses the Website.</p>
					<p class="content-para">1.26 <strong>“Website”</strong> means Merchantrade’s designated website: www.eremit.com.my which is
open to access by Users</p>
					<p class="content-para">1.27 Unless repugnant to the context herein in these terms:-
						 <ol type="a">
							 <li>reference to a particular gender shall be deemed to include a reference to the
other gender.</li>
							 <li>reference to singular shall include the plural vice versa.
</li>
							 <li>reference to word “include” or “including”, wherever appearing in these Terms
shall be read as if the word “without limitation “inserted thereafter</li>
						 </ol>
						THE USER HEREBY AGREES TO SUBSCRIBE TO THESE SERVICES UPON THE TERMS HEREIN CONTAINED.
					</p>
					

					<p class="content-para"><strong>2. ELIGIBILITY</strong></p>
					<p class="content-para">2.1 The User must have attained eighteen (18) years of age and permitted under
Applicable Laws to apply and use the e-Remit System.</p>
					<p class="content-para">2.2 AUser must meet the Customer Due Diligence requirements imposed by Merchantrade
and Applicable Laws.</p>
					<p class="content-para">2.3 A Visitor who accesses the Website or avail the Services acknowledges that he may be
violating the Applicable Laws and agrees to be solely and absolutely liable for any
liabilities arising therefrom and undertakes to indemnify Merchantrade against any
Loss incurred by Merchantrade thereto.</p>
					<p class="content-para"><strong>3. SERVICE CHARGE AND FOREIGN EXCHANGE RATE</strong></p>
					<p class="content-para">3.1 For each remittance transaction through the e-Remit System, the User shall be liable
for Service Charge. The applicable Service Charge and foreign exchange rate are based
on the latest Rate Table provided by Merchantrade from time to time. The User agree
that Merchantrade shall have the absolute and sole discretion in determination of the
said Service Charge and applicable foreign exchange rate. The latest Rate Table shall
be applicable after being posted on
						<a href="www.eremit.com.my">www.eremit.com.my</a>
					</p>

					<p class="content-para"><strong>4. USER'S RESPONSIBILITIES</strong></p>
					<p class="content-para">4.1 User warrants that all particulars and information provided by the User to facilitate
approval and registration for the Services are true, accurate, current, complete and
not misleading. The User further undertakes to forthwith notify Merchantrade of any
changes to the User’s personal particulars and such other information as required by
Merchantrade, in writing, by way of prepaid registered post, email and by producing
original identification documents for verification purposes.</p>
					<p class="content-para">4.2 User undertakes to indemnify Merchantrade, its employees, directors, officers,
representatives, affiliates, subsidiaries and agents for any Loss caused to
Merchantrade arising from the User providing untrue, inaccurate, out-of-date,
incomplete or misleading information or particulars.</p>
					<p class="content-para">4.3 User shall take all such measures and steps as may be necessary (including but not
limited to changing User’s password from time to time) to protect User’s password
and to prevent unauthorised use of User’s Account or unauthorised disclosure of the
User’s password. The User acknowledges that it is the User’s sole and absolute
responsibility to maintain secrecy and confidentiality of the User’s password and the
User shall be fully and absolutely liable for all transactions and activities that occur
under the User’s username and password including unauthorised use and misuse.</p>
					<p class="content-para">4.4 User shall notify Merchantrade either in writing or by way of email through the User’s
designated email, if the User becomes aware of or reasonably believe that there is any
unauthorized use of the User’s Account or any other breach of security, and to cooperate with Merchantrade in all such investigation. This shall include (i) unauthorized
usage of username and password (ii) receipt by User of any transaction confirmation,
fund transfer or such activities that User did not authorize or (iii) any inaccurate
information in User’s current transaction or transaction history.
</p>
					<p class="content-para">4.5 User shall be responsible and liable for any third party gaining access to the e-Remit
System through the use of the User’s username and password, and in such event, the
User shall hold Merchantrade, its employees, directors, officers, representatives,
affiliates, subsidiaries and agents harmless against any Loss arising from any such
unauthorised access. Any transaction and/or activity arising from the usage of the
User’s username and password will be deemed the User’s transaction and/or
activities, and Merchantrade is under no obligation whatsoever to verify authenticity
of such transactions and/or activity.</p>
					<p class="content-para">4.6 User is responsible to log out after each session of accessing e-Remit System.</p>
					<p class="content-para">4.7 User acknowledges and agrees that:-
						<ol type="a">
							<li>unless there are sufficient funds deposited with Merchantrade in advance for
the amount requested to be remitted by the User inclusive of applicable Service
Charge and Taxes, Merchantrade comes under no obligation whatsoever to act
on the User’s payout instruction.
</li>
							<li>Merchantrade may restrict, decline or refuse User’s request for carrying out
Transaction at any time at Merchantrade’s sole discretion without assigning any
reasons thereto.</li>
							<li>although the Services may be accessible outside of Malaysia via the Website,
Merchantrade accepts no liabilities whatsoever arising from any noncompliance with the laws of any country other than Malaysia for the use of the
Services.
</li>
							<li>the User must specify in the relevant column/field provided in the e-Remit
System, the source of remittance fund and purpose of the remittance/money
transfer each time a transaction is conducted.
</li>
							<li>Merchantrade may rely on the registration information and the remittance
payout information provided by the User to Merchantrade. Any errors in the
information provided by the User including misidentification of Beneficiary,
incorrect account holder’s names, account numbers and Beneficiary Card
number shall be at the User’s sole responsibility and risk. The User undertakes
to hold Merchantrade harmless from all losses and damages arising from any
Merchantrade’s act or omission in reliance upon any such erroneous
information</li>
							<li>any crediting of remittance payout to the Beneficiary Card shall be subject to
limitations imposed by the bank or financial institution from which the
Beneficiary Card is issued. Subject to this <strong>clause 4.7(f)</strong>, User further undertakes
to hold Merchantrade harmless from all losses and liabilities arising from the
User’s failure to remit funds to the Beneficiary Card. </li>
							<li>the User acknowledges that the duration for remittance payout delivery to the
Beneficiary shall be as stipulated in the e-Remit System.
</li>
							<li>in the event the User cancels a Transaction or the Transaction is unsuccessful
due to reasons of erroneous particulars provided by the User, the User shall
remain liable for the applicable Service Charge and Taxes.
</li>
							<li>without limitation, the User acknowledges that it must maintain an internet
banking facilities account with FPX participating bank(s) in Malaysia for the use
of the Services. In addition, the User may also opt to deposit funds for
remittance purposes (including applicable Service Charge and Taxes) to
Merchantrade from the User’s Merchantrade Money Visa Prepaid Card or bank
debit card</li>
							<li>FPX is a separate legal entity and use of FPX services is subject to terms,
requirements and restrictions imposed by FPX and charges FPX imposes on the
User. User shall ascertain and update itself of such applicable terms and 
conditions. Merchantrade is neither liable nor responsible for any Loss incurred
by the User or any other person arising from the User’s utilisation of the FPX
services.</li>
							<li>Merchantrade reserves sole and absolute discretion to determine and impose
limits for the Transactions performed through the e-Remit System whether in
amount, frequency or otherwise in accordance to the Applicable Laws and that
Merchantrade reserves absolute rights to vary such limitations subject to
requirements / amendments to the Applicable Laws and / or Merchantrade’s
internal policies.
</li>
							<li>the Services is subject to Bank Negara Malaysia’s Cautionary Statement
whereby BNM does not guarantee the remittance of funds by Merchantrade
and User take the risk of any Loss suffered from remittance. A copy of the
Cautionary Statement also known as Notice to Customers can be viewed at 
								<a href="www.eremit.com.my">www.eremit.com.my</a>
							</li>
						</ol>
					</p>
					<p class="content-para"><strong>5. PASSWORD</strong></p>
					<p class="content-para">5.1 In the event the User has forgotten the dedicated password to access the System, the User:-
						<ol type="a">
							<li>shall log-in to www.eremit.com.my and click on “Forgot your password” to reset
Password where the System will generate a link which will be send to User’s
designated email address. </li>
							<li>acknowledges that upon a request to reset password, the User’s existing
password will be invalidated and the User shall be required to create a new
password by clicking on the link that has transmitted to the User’s designated
email address.</li>
							<li>acknowledges and agree that the User will be subject to identity verification to
Merchantrade’s satisfaction, Merchantrade will generate a link to the User’s
designated email address registered with Merchantrade to enable User to
create a new password.</li>
						</ol>
					</p>
					<p class="content-para"><strong>6. PROHIBITIONS AND RESTRICTIONS</strong></p>
					<p class="content-para">6.1 User shall not:-
						<ol type="a">
							<li>use the Services in any way which will deprive other Users of their legitimate
right to use the Services.
</li>
							<li>use the Website for unlawful purposes in any jurisdiction or in breach of these
Terms.
</li>
							<li>use the Services for any unlawful or illegal activity or in breach of any Applicable
Laws including without limitation and such subsequent amendments thereto.</li>
							<li>allow access, re-sell or re-provide the Services to any other person.</li>
							<li>modify, copy, distribute, reproduce, transmit, display, perform, publish, upload,
post, license, create derivative works from, transfer or sell any information,
designs, logos, trademarks, software or services obtained from the Website.</li>
							<li>post or transmit any unlawful, fraudulent, libelous, defamatory, obscene,
pornographic, profane, threatening, abusive, hateful, offensive, or otherwise
objectionable information or statement of any kind without limitation, any
information or statement constituting or encouraging conduct that would
tantamount to criminal offence, give rise to civil liability and/or violates any
Applicable Laws.
</li>
							<li>post or transmit any messages that amount to advertising material, touting or
sale of, or offer to sell, any product or service.
</li>
							<li>transmit or disseminate advertising material, chain letters, spam, junk mail or
other type of unsolicited messages.
</li>
							<li>post or transmit or disseminate viruses, worms, Trojan horses or other harmful,
disruptive or destructive files.</li>
							<li>post, publish, transmit, reproduce, distribute, or in any way exploit any
information , software or other material obtained from or through the Website
for commercial purposes.</li>
							<li>attempt to decompile or reverse engineer any software available in the
Website.
</li>
							<li>attempt to hack into the Website or otherwise attempt to subvert any firewall
or other security measure of the Website.</li>
						</ol>
					</p>
					<p class="content-para">6.2 In the event, the Website contains bulletin boards, chat rooms, access to mailing lists
or other communication facilities, the User shall only send and receive messages that
are proper and related to the particular subject forum/purposes only.
</p>
					<p class="content-para">6.3 Any software provided on, by or through the Website for a specific purpose shall only
be used for that purpose and no other.
</p>
					<p class="content-para">6.4 User shall comply with the rules of any network through which User access the
Services.
</p>
					<p class="content-para">6.5 User shall comply with and shall not contravene Applicable Laws, without limitation
laws of such jurisdiction relating to the use of the Services.
</p>
					<p class="content-para">6.6 The Services is only available in Malaysia. If for any reason the User uses the Services
outside Malaysia, Merchantrade may not support the Services and User’s use of the
Services at the User’s own risk including the risk that the use thereof violates local laws
in the country/jurisdiction.
</p>
					<p class="content-para">6.7 User acknowledges and agrees that the Services without limitation and in addition to
these Terms is subject to availability of FPX and such requirements, conditions and
restrictions imposes on the User. Merchantrade shall not be liable to User or 3rd party
for any acts or omissions of FPX. User undertakes to exercise due diligence to ascertain
the terms of FPX services.
</p>
					<p class="content-para"><strong>7. LIMITATION OF LIABILITY</strong></p>
					<p class="content-para">7.1 Merchantrade’s liablity to the User under this Term is strictly limited to the refund of
the remittance amount transacted by the User through the Services (excluding
charges, costs of expenses of whatsoever nature including FPX or bank charges the
User may have incurred) which remains undelivered / unpaid to the Beneficiary,
SUBJECT TO ALWAYS that such failure is not contributed by any act or ommission of
the User. </p>
					<p class="content-para">7.2 Except for Merchantrade’s refund obligation under <strong>clause 7.1</strong>, under no circumstances
Merchantrade will be liable for any Loss to the User whether or not such Loss is due
to wilfull act, omission, neglect, default or non-performance on the part of
Merchantrade, its directors, shareholders, employees or agents or such other
person(s) / entity(ies) engaged by Merchantrade to facilitate the Services</p>
					<p class="content-para">7.3 Subject to and without prejudice to <strong>clause 7.1</strong> and <strong>7.2</strong> or any other provisions under
this Terms to the contrary, Merchantrade’s cumulative liablity for all losses, claims,
suits, controversies, breaches or damages for any cause whatsoever (including but not
limited to those arising out of or related to this Agreement) and regardless of the form
of action or legal theory <u><strong>SHALL NOT EXCEED RM100-00.</strong></u></p>
					<p class="content-para">7.4 Without limitation to <strong>clause 7</strong> of these Terms, Merchantrade shall not be responsible
or liable for any Loss incurred or suffered by the User or any third party arising from:-
<ol type="a">
	<li>User’s inability to perform any transactions due to the limits set by
Merchantrade from time to time; or</li>
	<li>any intrusion or attack by any person or party on the hardware, software, the
e-Remit System through internet, mobile, tablet devices and / or such other
electronic devices (capable of supporting the Services application) including but
not limited to viruses, Trojan Horses, malware and / or macros or other harmful
componentsor disabling devices that may suspend, disrupt, or disbale the eRemit System or any part thereof. </li>
</ol>
</p>
					<p class="content-para"><strong>8. DISCLAIMER</strong></p>
					<p class="content-para">8.1 Due to the inherent hazards of electronic distribution, User agree and accept that
Services may be unavailable from time to time due to required maintenance,
electronic or other systems failures or interruptions (whether of Merchantrade or any
third party) or other disruptions. Merchantrade, its suppliers and their respective
affiliates, officers, distributors and employees shall not be liable to the User for any
Loss suffered by the User as a result thereof. Merchantrade does not guarantee that
Services will be uninterrupted, secure, error-free and free from viruses or other
harmful components.
</p>
					<p class="content-para">8.2 Merchantrade cannot and does not endorse or review, and cannot be responsible for,
the messages, views, opinions and recommendations of third parties, User and
organisations of deemed interest. Merchantrade does not advocate any commercial dealings in any third party products or investments. The inclusion in Services of a link
to other web site(s) or resources does not imply any form of endorsement by
Merchantrade. Any User seeking recourse shall do so against such party providing such
advice, products or services. However, Merchantrade requires all Users to comply with
all relevant laws, as well as the rules set out in the Website, and ensure that the law
and the rules are observed and complied with. Without limitation, User acknowledges
that Merchantrade is not responsible for the privacy and confidentiality of any
personal information provided by the User to the other linked websites in any manner
whatsover.</p>
					<p class="content-para">8.3 Merchantrade reserves absolute discretion without notice to the User, to introduce
changes to the features appearing in the Website from time to time without limitation
to add, modify or remove such features.
</p>
					<p class="content-para">8.4 In amplification to any provisions of these Terms, Merchantrade does not guarantee
storage of any data stored by the User in the System and excludes all liability for loss
of data.</p>
					<p class="content-para"><strong>9. INDEMNITY</strong></p>
					<p class="content-para">9.1 User shall indemnify Merchantrade, its directors, officers, its suppliers, their
employees, subsidiaries, related corporation, associates, distributors and affiliates
against any and all Loss suffered by Merchantrade, its directors, officers, its suppliers,
their employees, subsidiaries, related corporation, associates, distributors and
affiliates to any person as a result of any breach of these Terms without limitation to
any acts or omission of the Authorised Person in breach of these Terms</p>
					<p class="content-para"><strong>10. NOTICES</strong></p>
					<p class="content-para">10.1 All notices are deemed served on the User immediately after it is posted on the
Website or sent to the User’s mobile number and/or designated e-mail address
(despite evidence to the contrary) as set out in the Registration Form or such mobile
number and/or e-mail address of which notice has been given to Merchantrade by the
User in writing by way of prepaid registered post.
</p>
					<p class="content-para"><strong>11. FORCE MAJEURE</strong></p>
					<p class="content-para">11.1 Merchantrade, its correspondent agents and / or any entities involved in the process
of remittance transfer shall not be liable for any loss or damage arising from any delay
or failure in the remittance transmission due to any government order, law, levy tax
or exchange restriction or any other cause beyond the control of Merchantrade
(including but not limited to Acts of God).</p>
					<p class="content-para"><strong>12. ASSIGNMENT</strong></p>
					<p class="content-para">12.1 This Agreement is not assignable by the User.</p>
					<p class="content-para"><strong>13. THIRD PARTY</strong></p>
					<p class="content-para">13.1 Nothing in this Terms confers or shall purport to confer on any third party any benefit
or any right to enforce any terms or conditions herein.</p>
					<p class="content-para"><strong>14. JURISDICTION & GOVERNING LAWS</strong></p>
					<p class="content-para">14.1 The terms and conditions herein and all remittance transactions by way of e-Remit
Services shall be governed and interpreted according to the laws of Malaysia and
subject to the exclusive jurisdiction of the Courts of Malaysia. </p>
					<p class="content-para">14.2 These Terms between Merchantrade and the User shall be deemed to have been
made and executed at Merchantrade’s office in Petaling Jaya and any breach of the
terms and conditions stated herein shall be deemed to have arisen in Petaling Jaya
irrespective of where the User carries out business or where the Transaction may have
taken place.</p>

					<p class="content-para"><strong>15. DISCLOSURE</strong></p>
					<p class="content-para">15.1 The User hereby agrees that Merchantrade’s rights to the User’s and Beneficiary(ies)
information and disclosure shall be in accordance with Merchantrade’s Privacy Notice.
User further consents to holding, collection and use of all personal data provided by
the User arising from the Services in accordance with the Privacy Notice as may be
amended from time to time.
</p>
					<p class="content-para">15.2 In amplification and not in derogation of <strong>clause 15.1</strong> above of these Terms,
Merchantrade reserves the right to disclose part of or all information concerning the
User and / or Beneficiary(ies) at such time and in such manner as is permitted or
required by the Applicable Laws to the relevant authorities. </p>
					<p class="content-para"><strong>16. TIME & NON-WAIVER</strong></p>
					<p class="content-para">16.1 Time wherever mentioned shall be the essence of these Terms and no failure to
exercise and delay in exercising on the part of Merchantrade of any right, power or
privilege under these Terms shall operate as a waiver thereof, nor shall any single or
partial exercise of any right, power or privilege preclude any other or further exercise
thereof or the exercise of any other right, power or privilege. The rights and remedies
herein provided are cumulative and not exclusive of any rights or remedies provided
by law.</p>

					<p class="content-para"><strong>17. EXCHANGE RATE</strong></p>
					<p class="content-para">17.1 The conversion of exchange rate are based on the latest Rate Table provided by
Merchantrade and are subject to change without prior notice at Merchantrade’s sole
and absolute discretion. </p>

					<p class="content-para"><strong>18. SEVERALIBILITY</strong></p>
					<p class="content-para">18.1 If any provision in these Terms is found or held to be invalid or unenforceable, then
the meaning of such provision shall be construed to the fullest extent allowed by law
so as to render the provision valid and enforceable, and if no such constrain is possible,
the invalidity or unenforceability of such provision shall not effect the other provisions
of these Terms.</p>

					<p class="content-para"><strong>19. REGULATORY</strong></p>
					<p class="content-para">19.1 The User acknowledges that e-Remit Services shall be subject to the applicable rules,
guidelines and requirements of Bank Negara Malaysia</p>

					<p class="content-para"><strong>20. AMENDMENTS</strong></p>
					<p class="content-para">20.1 Merchantrade reserves the right to vary, alter and amend any or all of these Terms
herein and announce changes to its Services and to post them on
<a href="www.eremit.com.my">www.eremit.com.my</a>. User’s continued use of the Services offered by Merchantrade
after such variation, alteration and amendments have been posted constitutes User’s
agreement to be bound by them. The User shall have no recourse whatsoever against
Merchantrade for any Loss as a result of such variation, alteration, amendment or
otherwise.
</p>

					<p class="content-para">20.2 No rule of construction applies to the disadvantage of Merchantrade as Merchantrade
was responsible for the preparation of this Agreement or any part of it.</p>
					<p class="content-para"><strong>21. ENGLISH VERSION</strong></p>
					<p class="content-para">
						21.1 In the event these Terms are translated into a language other than English, it is done
solely for convenience purpose, with only the English version of these Terms shall be
valid and binding.
					</p>

					<p class="content-para"><strong>22. DISCREPANCY AND CONFLICT</strong></p>
					<p class="content-para">
						22.1 In the event there is conflict or discrepancy between any of the provisions of these
Terms and such other terms appearing elsewhere in the Website, the Terms to the
extent of such discrepancies and / or conflict shall take priority and precedence for all
intents and purposes.
					</p>

					<p class="content-para"><strong>23. SURVIVAL</strong></p>
					<p class="content-para">
						23.1 The obligations and responsibilities of the User under these Terms by their nature
should survive termination shall so survive. 
					</p>
					<p class="content-para"><strong>24. TITLE AND HEADINGS</strong></p>
					<p class="content-para">
						24.1 The title and headings of clauses of these Terms are solely for convenience of
reference and will not be used in interpreting or construing the Terms.
					</p>
				</div>
			</div>
		</div>


		<div class="divider"></div>
	</div>
</template>
<script>
import DownloadApp from "../../shared/commercial/DownloadApp.vue";
import NavHeader from "../../shared/commercial/NavHeader.vue";
import PrivacySidebar from "../../components/privacysidebar.vue";
import SignUpFooter from "../../shared/commercial/SignUpFooter.vue";

export default {
  name: "Dashboard",

  components: { DownloadApp, NavHeader, SignUpFooter, PrivacySidebar },
};
</script>
<style scoped>
strong{
	font-weight: bold !important;
}
</style>